import * as React from 'react'
import { Row } from 'antd'
import { isMobile } from 'react-device-detect'

const sidePadding = isMobile ? '8%' : '12%'

const containerStyle = {
  paddingRight: sidePadding,
  paddingLeft: sidePadding,
}

const Container = ({ children, className }: { children: any, className?: string }) => (
  <Row
    type="flex"
    justify="center"
    gutter={{ xs: 8, md: 24 }}
    style={containerStyle}
    className={className}
  >
    {children}
  </Row>
)

export default Container
